import { http } from '@/lib'
import { Reimbursement } from '@/types/api'

import { useAsyncFn } from '@clara/hooks'

export async function getReimbursement(uid: string) {
  return http.get<Reimbursement>(`/${uid}`).then((response) => response.data)
}

export function useGetReimbursement() {
  return useAsyncFn(async (uid: string) => {
    const response = await getReimbursement(uid)

    return response
  })
}
